import { render, staticRenderFns } from "./RecordItem.vue?vue&type=template&id=e08aa000&scoped=true"
import script from "./RecordItem.vue?vue&type=script&lang=js"
export * from "./RecordItem.vue?vue&type=script&lang=js"
import style0 from "./RecordItem.vue?vue&type=style&index=0&id=e08aa000&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08aa000",
  null
  
)

export default component.exports